'use client'

import CharacterJA from './assets/character_ja.svg'

import DownloadQrcode from '../DownloadQrcode'

import { isCurrentTimeInRange } from '@/utils/date'
import { GLASSIS_MAIN_OPEN_TIME, GLASSIS_TEASER_OPEN_TIME } from '@/features/promotion/constants'
import { Locales } from '@/utils/language'
import { cn } from '@/shared/utils'

const LargeDownloadBanner = ({ locale }: { locale?: Locales }): JSX.Element => {
  const isKorean = locale === Locales.KO_KR
  const isJapanese = locale === Locales.JA_JP
  const imageSource = isCurrentTimeInRange({
    from: GLASSIS_TEASER_OPEN_TIME,
    to: GLASSIS_MAIN_OPEN_TIME,
  })
    ? '/images/kr/glassis_splash.webp'
    : '/images/kr/splash.webp'

  return (
    <div className="fixed w-[344px] h-[337px]">
      <div>
        {isJapanese && <CharacterJA />}
        {isKorean && <img src={imageSource} alt="2024 brand film" width={360} height={520} />}

        <div
          className={cn('absolute right-0', {
            'top-[443px]': isKorean,
            'top-[96px]': !isKorean,
          })}
          aria-label="app download qr area"
        >
          <DownloadQrcode size={140} level="L" bgColor="transparent" />
        </div>
      </div>
    </div>
  )
}

export default LargeDownloadBanner
